/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Remember, per sibling group, the last product viewed for each colour and reveal it on every page,
  // so navigating Silver-2 -> Gold -> Silver returns to Silver-2 rather than the default Silver-1.
  function initSiblingMemory() {
    var containers = document.querySelectorAll('[data-sibling-memory]');

    Array.prototype.forEach.call(containers, function (container) {
      var group = container.getAttribute('data-sibling-group') || '';
      if (!group) return;

      var currentColor = container.getAttribute('data-sibling-current-color') || '';
      var currentHandle = container.getAttribute('data-sibling-current-handle') || '';
      var storeKey = 'siblingSel:' + group;

      // read this group's saved selections from the session
      var store = {};
      try { store = JSON.parse(sessionStorage.getItem(storeKey)) || {}; } catch (e) { store = {}; }

      // remember the current product as the selection for its colour
      if (currentColor && currentHandle) {
        store[currentColor] = currentHandle;
        try { sessionStorage.setItem(storeKey, JSON.stringify(store)); } catch (e) {}
      }

      // group every swatch (visible and hidden) by its colour key
      var byColor = {};
      Array.prototype.forEach.call(container.querySelectorAll('[data-sibling-color][data-sibling-handle]'), function (swatch) {
        var color = swatch.getAttribute('data-sibling-color');
        (byColor[color] = byColor[color] || []).push(swatch);
      });

      // per colour: reveal the remembered product if present, else keep the server default; hide the rest
      Object.keys(byColor).forEach(function (color) {
        var list = byColor[color];
        var chosen = list.filter(function (s) { return s.getAttribute('data-sibling-handle') === store[color]; })[0];
        if (!chosen) chosen = list.filter(function (s) { return s.style.display !== 'none'; })[0] || list[0];
        list.forEach(function (swatch) { swatch.style.display = swatch === chosen ? '' : 'none'; });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSiblingMemory);
  } else {
    initSiblingMemory();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
